import { useObserver } from "mobx-react";
import React from "react";
import { TbAlertTriangleFilled } from "react-icons/tb";
import { useStores } from "../../../store";
import {
  AiFillWarning,
  AiOutlineCheckCircle,
  AiOutlineIssuesClose,
} from "react-icons/ai"; // Icon for the warning

const MCQTestOverview = ({
  testName,
  numberOfQuestions,
  cutOff,
  sections,
  onEdit,
}) => {
  const { RecuiterStore } = useStores();
  return useObserver(() => (
    <div className="container  ">
      {isNaN(numberOfQuestions) || !numberOfQuestions ? (
        <div className="w-full md:mx-8 mx-4  mt-5 flex flex-col items-start space-y-4">
          {/* Header Section */}
          <div className="flex items-center space-x-2">
            <AiOutlineIssuesClose className="text-red-500 text-3xl" />
            <span className="text-red-500 font-bold text-lg ">MCQ test</span>
          </div>

          {/* Warning Message Section */}
          <div className="flex items-center space-x-2">
            <AiFillWarning className="text-yellow text-2xl" />
            <span className="text-yellow text-sm font-semibold">
              You skipped this section
            </span>
          </div>

          {/* Divider */}
        </div>
      ) : (
        <div className=" md:mx-8 mx-4 mt-5 mb-3 ">
          <div className="flex justify-between items-center mb-4">
            <div className="flex items-center space-x-2">
              <AiOutlineCheckCircle className="text-green-500 text-3xl" />
              <span className="text-green-500 font-bold text-lg ">
                MCQ test
              </span>
            </div>
            {/* <button
            onClick={onEdit}
            className="text-primary text-sm flex flex-row hover:underline">
            Edit details <RiEditLine className="mt-1 ml-1" />
          </button> */}
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-4  text-gray-800">
            <div className="flex items-center">
              <span className=" pl-2">
                Assessment Name: <span className="font-bold">{testName}</span>
              </span>
            </div>
            <div className="flex items-center">
              <span className=" pl-2">
                Number of questions:{" "}
                <span className="font-bold">{numberOfQuestions}</span>
              </span>
            </div>
         
                <div className="flex items-center">
                  <span className=" pl-2">
                    Cut off: <span className="font-bold">{cutOff !== undefined && cutOff !== null && cutOff !== "" && cutOff !== "undefined" ? `${cutOff}%` : "Not mentioned"}</span>
                  </span>
                </div>

            {sections.map((section, index) => (
              <div key={index} className="flex items-center">
                <span className=" pl-2">
                  {section.name}:{" "}
                  <span className="font-bold">
                    {section.questions} Questions
                  </span>
                </span>
              </div>
            ))}
          </div>
          {RecuiterStore.jobPostDetails.mcqTestDetails.skipped && (
            <div className=" p-4 rounded-lg text-yellow text-lg mb-4 flex justify-center items-center">
              <TbAlertTriangleFilled className="mr-3 text-3xl" />
              <span>
                you skipped this section, add MCQ test to make your interview
                process within time
              </span>
            </div>
          )}
        </div>
      )}
    </div>
  ));
};

export default MCQTestOverview;
